import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IUserSelectorBuilder from "../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

export type Inputs = "idUser";
export type Buttons = "aceptar" | "cancelar";

export const empleadoFormConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "idUser",
      label: "Empleado",
      bts: { mCol: 12 },
      component: IUserSelectorBuilder,
      props: {}
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Guardar",
      isSubmit: true,
      bts: { mCol: 6 },
      component: IButtonBuilder,
      props: {}
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: { mCol: 6 },
      component: IButtonBuilder,
      props: {}
    }
  ],
  validations: {
    idUser: {
      required: true
    }
  },
  rows: [["idUser"], ["aceptar", "cancelar"]]
};
